// export this package's api
import EditorList from './EditorList';

export default EditorList;



// WEBPACK FOOTER //
// ./src/index.js